import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './translations/en';
import { nl } from './translations/nl';

const translations = {
  en: {
    translation: en,
  },
  nl: {
    translation: nl,
  },
};

const detectorOptions = {
  // order and from where user language should be detected
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'locale',

  // cache user language
  caches: ['localStorage'],
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: detectorOptions,
    resources: translations,
    whitelist: ['en', 'nl'],
    nonExplicitWhitelist: true,
    fallbackLng: 'en',
    cleanCode: true,
    //debug: true,
    //lng: 'nl',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
